// DO NOT EDIT MANUALLY! This file is generated from Airtable: "PowerUp-Daily"

import { Value } from './powerUpDaily.types';

// prettier-ignore
const powerUpDaily: Value[] = [
  {
    "date": "2025-04-29",
    "power_up_1": "pu_companions_techbro",
    "power_up_2": "pu_services_hash_hackers",
    "power_up_3": "pu_companions_curious_inlaws",
    "starts_at": 1745884800000
  },
  {
    "date": "2025-04-30",
    "power_up_1": "pu_gear_satellite_modem",
    "power_up_2": "pu_gear_knee_pads",
    "power_up_3": "pu_services_decentralized_data_storage",
    "starts_at": 1745971200000
  },
  {
    "date": "2025-05-01",
    "power_up_1": "pu_services_hash_hounds",
    "power_up_2": "pu_gear_harness",
    "power_up_3": "pu_companions_skeptical_partner",
    "starts_at": 1746057600000
  },
  {
    "date": "2025-05-02",
    "power_up_1": "pu_specials_eth_etf",
    "power_up_2": "pu_specials_mined_first_bitcoin",
    "power_up_3": "pu_specials_gemz_on_x",
    "starts_at": 1746144000000
  },
  {
    "date": "2025-05-03",
    "power_up_1": "pu_companions_techbro",
    "power_up_2": "pu_services_hodl_strategy_consultant",
    "power_up_3": "pu_gear_pickaxe",
    "starts_at": 1746230400000
  },
  {
    "date": "2025-05-04",
    "power_up_1": "pu_services_virtual_mining_coach",
    "power_up_2": "pu_companions_early_adopter_sibling",
    "power_up_3": "pu_specials_denver_eth_conference",
    "starts_at": 1746316800000
  },
  {
    "date": "2025-05-05",
    "power_up_1": "pu_services_mule_rentals",
    "power_up_2": "pu_gear_water_bottle",
    "power_up_3": "pu_gear_oil_immersed_rigs",
    "starts_at": 1746403200000
  },
  {
    "date": "2025-05-06",
    "power_up_1": "pu_services_nft_gallery",
    "power_up_2": "pu_companions_crypto_daytrader",
    "power_up_3": "pu_services_blockbuster_excavation",
    "starts_at": 1746489600000
  },
  {
    "date": "2025-05-07",
    "power_up_1": "pu_gear_satellite_modem",
    "power_up_2": "pu_services_smart_contract_builder",
    "power_up_3": "pu_services_rig_optimization_service",
    "starts_at": 1746576000000
  },
  {
    "date": "2025-05-08",
    "power_up_1": "pu_services_crypto_concierge",
    "power_up_2": "pu_services_rig_menders",
    "power_up_3": "pu_services_crypto_compliance_check",
    "starts_at": 1746662400000
  },
  {
    "date": "2025-05-09",
    "power_up_1": "pu_services_hash_hackers",
    "power_up_2": "pu_services_blockchain_security_audit",
    "power_up_3": "pu_specials_consensus_conference",
    "starts_at": 1746748800000
  },
  {
    "date": "2025-05-10",
    "power_up_1": "pu_companions_nft_influencer",
    "power_up_2": "pu_services_mine_masters",
    "power_up_3": "pu_services_blockbuster_excavation",
    "starts_at": 1746835200000
  },
  {
    "date": "2025-05-11",
    "power_up_1": "pu_companions_techbro",
    "power_up_2": "pu_gear_knee_pads",
    "power_up_3": "pu_gear_first_aid_kit",
    "starts_at": 1746921600000
  },
  {
    "date": "2025-05-12",
    "power_up_1": "pu_companions_data_scientist",
    "power_up_2": "pu_services_mine_canaries",
    "power_up_3": "pu_companions_ux_designer",
    "starts_at": 1747008000000
  },
  {
    "date": "2025-05-13",
    "power_up_1": "pu_companions_wired_pm",
    "power_up_2": "pu_services_nft_gallery",
    "power_up_3": "pu_services_mine_canaries",
    "starts_at": 1747094400000
  },
  {
    "date": "2025-05-14",
    "power_up_1": "pu_gear_ups_backup",
    "power_up_2": "pu_services_hash_hackers",
    "power_up_3": "pu_gear_pickaxe",
    "starts_at": 1747180800000
  },
  {
    "date": "2025-05-15",
    "power_up_1": "pu_companions_reclusive_backend_dev",
    "power_up_2": "pu_companions_curious_inlaws",
    "power_up_3": "pu_gear_water_bottle",
    "starts_at": 1747267200000
  },
  {
    "date": "2025-05-16",
    "power_up_1": "pu_gear_first_aid_kit",
    "power_up_2": "pu_gear_oil_immersed_rigs",
    "power_up_3": "pu_services_token_tutors",
    "starts_at": 1747353600000
  },
  {
    "date": "2025-05-17",
    "power_up_1": "pu_gear_lamp",
    "power_up_2": "pu_gear_ear_protection",
    "power_up_3": "pu_companions_crypto_daytrader",
    "starts_at": 1747440000000
  },
  {
    "date": "2025-05-18",
    "power_up_1": "pu_gear_hardhat",
    "power_up_2": "pu_services_hodl_strategy_consultant",
    "power_up_3": "pu_gear_water_bottle",
    "starts_at": 1747526400000
  },
  {
    "date": "2025-05-19",
    "power_up_1": "pu_gear_protective_gloves",
    "power_up_2": "pu_gear_sturdy_boots",
    "power_up_3": "pu_gear_pickaxe",
    "starts_at": 1747612800000
  },
  {
    "date": "2025-05-20",
    "power_up_1": "pu_services_decentralized_data_storage",
    "power_up_2": "pu_services_hodl_strategy_consultant",
    "power_up_3": "pu_services_hash_hounds",
    "starts_at": 1747699200000
  },
  {
    "date": "2025-05-21",
    "power_up_1": "pu_specials_mined_first_bitcoin",
    "power_up_2": "pu_companions_serial_entrepreneur",
    "power_up_3": "pu_services_crypto_concierge",
    "starts_at": 1747785600000
  },
  {
    "date": "2025-05-22",
    "power_up_1": "pu_specials_dao",
    "power_up_2": "pu_services_smart_contract_builder",
    "power_up_3": "pu_services_transaction_fee_negotiator",
    "starts_at": 1747872000000
  },
  {
    "date": "2025-05-23",
    "power_up_1": "pu_specials_eth_etf",
    "power_up_2": "pu_specials_inhouse_physical_therapist",
    "power_up_3": "pu_gear_climbing_rope",
    "starts_at": 1747958400000
  },
  {
    "date": "2025-05-24",
    "power_up_1": "pu_companions_agile_coach",
    "power_up_2": "pu_specials_eth_etf",
    "power_up_3": "pu_specials_first_eth_validator",
    "starts_at": 1748044800000
  },
  {
    "date": "2025-05-25",
    "power_up_1": "pu_services_nft_gallery",
    "power_up_2": "pu_services_hash_haven",
    "power_up_3": "pu_gear_satellite_modem",
    "starts_at": 1748131200000
  },
  {
    "date": "2025-05-26",
    "power_up_1": "pu_specials_consensus_conference",
    "power_up_2": "pu_companions_hardware_hacker",
    "power_up_3": "pu_gear_sturdy_boots",
    "starts_at": 1748217600000
  },
  {
    "date": "2025-05-27",
    "power_up_1": "pu_gear_ear_protection",
    "power_up_2": "pu_services_virtual_mining_coach",
    "power_up_3": "pu_companions_cryptoconference_junkie",
    "starts_at": 1748304000000
  },
  {
    "date": "2025-05-28",
    "power_up_1": "pu_companions_hardware_hacker",
    "power_up_2": "pu_gear_satellite_modem",
    "power_up_3": "pu_gear_water_cooled_pc",
    "starts_at": 1748390400000
  },
  {
    "date": "2025-05-29",
    "power_up_1": "pu_companions_skeptical_partner",
    "power_up_2": "pu_specials_gemz_on_x",
    "power_up_3": "pu_services_decentralized_data_storage",
    "starts_at": 1748476800000
  },
  {
    "date": "2025-05-30",
    "power_up_1": "pu_services_hodl_strategy_consultant",
    "power_up_2": "pu_gear_water_cooled_pc",
    "power_up_3": "pu_companions_concerned_enviromentalist",
    "starts_at": 1748563200000
  },
  {
    "date": "2025-05-31",
    "power_up_1": "pu_services_blockchain_security_audit",
    "power_up_2": "pu_companions_crypto_daytrader",
    "power_up_3": "pu_gear_first_aid_kit",
    "starts_at": 1748649600000
  },
  {
    "date": "2025-06-01",
    "power_up_1": "pu_gear_gas_mask",
    "power_up_2": "pu_companions_wired_pm",
    "power_up_3": "pu_gear_oil_immersed_rigs",
    "starts_at": 1748736000000
  },
  {
    "date": "2025-06-02",
    "power_up_1": "pu_services_rig_optimization_service",
    "power_up_2": "pu_companions_techbro",
    "power_up_3": "pu_services_rig_rentals",
    "starts_at": 1748822400000
  },
  {
    "date": "2025-06-03",
    "power_up_1": "pu_companions_concerned_enviromentalist",
    "power_up_2": "pu_services_nft_gallery",
    "power_up_3": "pu_services_transaction_fee_negotiator",
    "starts_at": 1748908800000
  },
  {
    "date": "2025-06-04",
    "power_up_1": "pu_gear_sturdy_boots",
    "power_up_2": "pu_gear_cold_weather_gear",
    "power_up_3": "pu_gear_hardhat",
    "starts_at": 1748995200000
  },
  {
    "date": "2025-06-05",
    "power_up_1": "pu_services_nft_gallery",
    "power_up_2": "pu_companions_blockchain_evangelist",
    "power_up_3": "pu_gear_hardware_wallet",
    "starts_at": 1749081600000
  },
  {
    "date": "2025-06-06",
    "power_up_1": "pu_gear_oil_immersed_rigs",
    "power_up_2": "pu_gear_water_bottle",
    "power_up_3": "pu_gear_ear_protection",
    "starts_at": 1749168000000
  },
  {
    "date": "2025-06-07",
    "power_up_1": "pu_companions_data_scientist",
    "power_up_2": "pu_gear_sturdy_boots",
    "power_up_3": "pu_services_hodl_strategy_consultant",
    "starts_at": 1749254400000
  },
  {
    "date": "2025-06-08",
    "power_up_1": "pu_companions_intern",
    "power_up_2": "pu_services_hash_haven",
    "power_up_3": "pu_services_rig_menders",
    "starts_at": 1749340800000
  },
  {
    "date": "2025-06-09",
    "power_up_1": "pu_companions_concerned_enviromentalist",
    "power_up_2": "pu_gear_reflective_vest",
    "power_up_3": "pu_companions_serial_entrepreneur",
    "starts_at": 1749427200000
  },
  {
    "date": "2025-06-10",
    "power_up_1": "pu_services_crypto_compliance_check",
    "power_up_2": "pu_services_crypto_crane",
    "power_up_3": "pu_companions_digital_nomad",
    "starts_at": 1749513600000
  },
  {
    "date": "2025-06-11",
    "power_up_1": "pu_gear_first_aid_kit",
    "power_up_2": "pu_gear_hardhat",
    "power_up_3": "pu_services_rig_optimization_service",
    "starts_at": 1749600000000
  },
  {
    "date": "2025-06-12",
    "power_up_1": "pu_companions_nft_influencer",
    "power_up_2": "pu_companions_data_scientist",
    "power_up_3": "pu_services_hodl_strategy_consultant",
    "starts_at": 1749686400000
  },
  {
    "date": "2025-06-13",
    "power_up_1": "pu_gear_sturdy_boots",
    "power_up_2": "pu_services_hash_hackers",
    "power_up_3": "pu_specials_bitcoin_etf",
    "starts_at": 1749772800000
  },
  {
    "date": "2025-06-14",
    "power_up_1": "pu_specials_dao",
    "power_up_2": "pu_gear_ear_protection",
    "power_up_3": "pu_gear_tool_bag",
    "starts_at": 1749859200000
  },
  {
    "date": "2025-06-15",
    "power_up_1": "pu_services_hash_haven",
    "power_up_2": "pu_services_blockchain_security_audit",
    "power_up_3": "pu_companions_agile_coach",
    "starts_at": 1749945600000
  },
  {
    "date": "2025-06-16",
    "power_up_1": "pu_gear_first_aid_kit",
    "power_up_2": "pu_specials_denver_eth_conference",
    "power_up_3": "pu_companions_agile_coach",
    "starts_at": 1750032000000
  },
  {
    "date": "2025-06-17",
    "power_up_1": "pu_services_hash_haven",
    "power_up_2": "pu_companions_techbro",
    "power_up_3": "pu_services_hash_hounds",
    "starts_at": 1750118400000
  },
  {
    "date": "2025-06-18",
    "power_up_1": "pu_services_hash_hounds",
    "power_up_2": "pu_services_swap_services",
    "power_up_3": "pu_gear_hardware_wallet",
    "starts_at": 1750204800000
  },
  {
    "date": "2025-06-19",
    "power_up_1": "pu_gear_gas_mask",
    "power_up_2": "pu_specials_mined_first_bitcoin",
    "power_up_3": "pu_companions_early_adopter_sibling",
    "starts_at": 1750291200000
  },
  {
    "date": "2025-06-20",
    "power_up_1": "pu_gear_water_bottle",
    "power_up_2": "pu_companions_skeptical_partner",
    "power_up_3": "pu_gear_thermal_paste",
    "starts_at": 1750377600000
  },
  {
    "date": "2025-06-21",
    "power_up_1": "pu_specials_denver_eth_conference",
    "power_up_2": "pu_specials_eth_etf",
    "power_up_3": "pu_gear_lamp",
    "starts_at": 1750464000000
  },
  {
    "date": "2025-06-22",
    "power_up_1": "pu_services_mine_canaries",
    "power_up_2": "pu_specials_dao",
    "power_up_3": "pu_companions_early_adopter_sibling",
    "starts_at": 1750550400000
  },
  {
    "date": "2025-06-23",
    "power_up_1": "pu_companions_early_adopter_sibling",
    "power_up_2": "pu_companions_digital_nomad",
    "power_up_3": "pu_specials_inhouse_physical_therapist",
    "starts_at": 1750636800000
  },
  {
    "date": "2025-06-24",
    "power_up_1": "pu_gear_oil_immersed_rigs",
    "power_up_2": "pu_specials_gemz_on_x",
    "power_up_3": "pu_companions_crypto_daytrader",
    "starts_at": 1750723200000
  },
  {
    "date": "2025-06-25",
    "power_up_1": "pu_companions_data_scientist",
    "power_up_2": "pu_gear_water_cooled_pc",
    "power_up_3": "pu_companions_early_adopter_sibling",
    "starts_at": 1750809600000
  },
  {
    "date": "2025-06-26",
    "power_up_1": "pu_services_decentralized_data_storage",
    "power_up_2": "pu_companions_serial_entrepreneur",
    "power_up_3": "pu_companions_early_adopter_sibling",
    "starts_at": 1750896000000
  },
  {
    "date": "2025-06-27",
    "power_up_1": "pu_gear_climbing_rope",
    "power_up_2": "pu_gear_tool_bag",
    "power_up_3": "pu_gear_hardhat",
    "starts_at": 1750982400000
  },
  {
    "date": "2025-06-28",
    "power_up_1": "pu_gear_protective_gloves",
    "power_up_2": "pu_gear_climbing_rope",
    "power_up_3": "pu_gear_hardware_wallet",
    "starts_at": 1751068800000
  },
  {
    "date": "2025-06-29",
    "power_up_1": "pu_companions_reclusive_backend_dev",
    "power_up_2": "pu_gear_harness",
    "power_up_3": "pu_services_crypto_cloud_boost",
    "starts_at": 1751155200000
  },
  {
    "date": "2025-06-30",
    "power_up_1": "pu_companions_agile_coach",
    "power_up_2": "pu_gear_knee_pads",
    "power_up_3": "pu_gear_backpack",
    "starts_at": 1751241600000
  },
  {
    "date": "2025-07-01",
    "power_up_1": "pu_services_smart_contract_builder",
    "power_up_2": "pu_services_crypto_crane",
    "power_up_3": "pu_gear_lamp",
    "starts_at": 1751328000000
  },
  {
    "date": "2025-07-02",
    "power_up_1": "pu_services_token_tutors",
    "power_up_2": "pu_services_mule_rentals",
    "power_up_3": "pu_gear_water_bottle",
    "starts_at": 1751414400000
  },
  {
    "date": "2025-07-03",
    "power_up_1": "pu_companions_awkward_ceo",
    "power_up_2": "pu_companions_hardware_hacker",
    "power_up_3": "pu_specials_dao",
    "starts_at": 1751500800000
  },
  {
    "date": "2025-07-04",
    "power_up_1": "pu_specials_inhouse_physical_therapist",
    "power_up_2": "pu_gear_ear_protection",
    "power_up_3": "pu_companions_venture_capitalist",
    "starts_at": 1751587200000
  },
  {
    "date": "2025-07-05",
    "power_up_1": "pu_gear_thermal_paste",
    "power_up_2": "pu_specials_gemz_on_x",
    "power_up_3": "pu_gear_ear_protection",
    "starts_at": 1751673600000
  },
  {
    "date": "2025-07-06",
    "power_up_1": "pu_companions_nft_influencer",
    "power_up_2": "pu_gear_water_bottle",
    "power_up_3": "pu_specials_bitcoin_etf",
    "starts_at": 1751760000000
  },
  {
    "date": "2025-07-07",
    "power_up_1": "pu_specials_bitcoin_etf",
    "power_up_2": "pu_companions_agile_coach",
    "power_up_3": "pu_services_smart_contract_builder",
    "starts_at": 1751846400000
  },
  {
    "date": "2025-07-08",
    "power_up_1": "pu_gear_first_aid_kit",
    "power_up_2": "pu_services_swap_services",
    "power_up_3": "pu_gear_hand_radio",
    "starts_at": 1751932800000
  },
  {
    "date": "2025-07-09",
    "power_up_1": "pu_gear_sturdy_boots",
    "power_up_2": "pu_services_mine_masters",
    "power_up_3": "pu_gear_hardhat",
    "starts_at": 1752019200000
  },
  {
    "date": "2025-07-10",
    "power_up_1": "pu_services_token_tutors",
    "power_up_2": "pu_gear_first_aid_kit",
    "power_up_3": "pu_gear_satellite_modem",
    "starts_at": 1752105600000
  },
  {
    "date": "2025-07-11",
    "power_up_1": "pu_companions_agile_coach",
    "power_up_2": "pu_companions_wired_pm",
    "power_up_3": "pu_gear_tool_bag",
    "starts_at": 1752192000000
  },
  {
    "date": "2025-07-12",
    "power_up_1": "pu_gear_hand_radio",
    "power_up_2": "pu_gear_first_aid_kit",
    "power_up_3": "pu_gear_satellite_modem",
    "starts_at": 1752278400000
  },
  {
    "date": "2025-07-13",
    "power_up_1": "pu_services_mine_masters",
    "power_up_2": "pu_companions_blockchain_evangelist",
    "power_up_3": "pu_gear_hardhat",
    "starts_at": 1752364800000
  },
  {
    "date": "2025-07-14",
    "power_up_1": "pu_services_rig_rentals",
    "power_up_2": "pu_companions_concerned_enviromentalist",
    "power_up_3": "pu_services_mine_canaries",
    "starts_at": 1752451200000
  },
  {
    "date": "2025-07-15",
    "power_up_1": "pu_services_crypto_compliance_check",
    "power_up_2": "pu_companions_agile_coach",
    "power_up_3": "pu_gear_ear_protection",
    "starts_at": 1752537600000
  },
  {
    "date": "2025-07-16",
    "power_up_1": "pu_specials_first_eth_validator",
    "power_up_2": "pu_gear_pickaxe",
    "power_up_3": "pu_gear_tool_bag",
    "starts_at": 1752624000000
  },
  {
    "date": "2025-07-17",
    "power_up_1": "pu_gear_hardware_wallet",
    "power_up_2": "pu_gear_reflective_vest",
    "power_up_3": "pu_gear_ear_protection",
    "starts_at": 1752710400000
  },
  {
    "date": "2025-07-18",
    "power_up_1": "pu_companions_tech_journalist",
    "power_up_2": "pu_services_rig_optimization_service",
    "power_up_3": "pu_services_rig_menders",
    "starts_at": 1752796800000
  },
  {
    "date": "2025-07-19",
    "power_up_1": "pu_services_hodl_strategy_consultant",
    "power_up_2": "pu_services_crypto_crane",
    "power_up_3": "pu_services_rig_optimization_service",
    "starts_at": 1752883200000
  },
  {
    "date": "2025-07-20",
    "power_up_1": "pu_specials_first_eth_validator",
    "power_up_2": "pu_gear_gas_mask",
    "power_up_3": "pu_companions_wired_pm",
    "starts_at": 1752969600000
  },
  {
    "date": "2025-07-21",
    "power_up_1": "pu_companions_awkward_ceo",
    "power_up_2": "pu_services_decentralized_data_storage",
    "power_up_3": "pu_companions_digital_nomad",
    "starts_at": 1753056000000
  },
  {
    "date": "2025-07-22",
    "power_up_1": "pu_specials_bitcoin_etf",
    "power_up_2": "pu_services_token_tutors",
    "power_up_3": "pu_gear_gas_mask",
    "starts_at": 1753142400000
  },
  {
    "date": "2025-07-23",
    "power_up_1": "pu_companions_techbro",
    "power_up_2": "pu_companions_cryptoconference_junkie",
    "power_up_3": "pu_gear_tool_bag",
    "starts_at": 1753228800000
  },
  {
    "date": "2025-07-24",
    "power_up_1": "pu_services_mine_masters",
    "power_up_2": "pu_specials_dao",
    "power_up_3": "pu_gear_harness",
    "starts_at": 1753315200000
  },
  {
    "date": "2025-07-25",
    "power_up_1": "pu_services_mine_masters",
    "power_up_2": "pu_companions_concerned_enviromentalist",
    "power_up_3": "pu_companions_cryptoconference_junkie",
    "starts_at": 1753401600000
  },
  {
    "date": "2025-07-26",
    "power_up_1": "pu_companions_serial_entrepreneur",
    "power_up_2": "pu_services_crypto_cloud_boost",
    "power_up_3": "pu_gear_tool_bag",
    "starts_at": 1753488000000
  }
];
export default powerUpDaily;
